export default {
    created: function() {
        for(var i = 1; i <= 10; i++) {
            this.amountOptions.push(i);
        }
        let token = document.head.querySelector('meta[name="csrf-token"]');
        this.token = token.content;

        if(this.orderLine !== undefined){
            this.shape = this.orderLine.shape_code;
            this.length = this.orderLine.length;
            this.width = this.orderLine.width;
            this.radius = this.orderLine.thickness;
            this.thickness = this.orderLine.thickness;
        }
    },
    methods: {
        sendForm: function() {

            let _this = this;

            this.posting = true;

            let formData = new FormData();

            formData.append('free', 1);
            formData.append('orderOrOffer', 0);
            formData.append('category', this.category.id);
            formData.append('steel', this.activeSteel.id);
            formData.append('shape', this.shape);
            formData.append('length', this.length);
            formData.append('width', this.width);
            formData.append('thickness', this.thickness);
            formData.append('radius', this.radius);
            formData.append('amount', this.amount);

            let url = '/order-line/store';

            if(this.orderLine !== undefined){
                url = '/order-line/update/' + this.orderLine.id;
            }

            axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(function(response) {
                _this.posting = false;
                _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
            }, _this)
            .catch(function(error){
                _this.posting = false;
                _this.$awn.alert("Oeps, daar ging iets mis, probeert u het later nog eens");
            }, _this);
        },
        setOfferteAvailable: function() {
            this.fileUploaded = true;
        }
    },
    computed: {
        offerteAvailable: function() {
            if(this.fileUploaded) {
                return true;
            }

            if(this.shape == "Plat") {
                if(this.length == null || this.width == null || this.thickness == null) {
                    return false;
                }
            } else {
                if(this.length == null || this.radius == null) {
                    return false;
                }
            }

            return true;
        },
        uploadAvailable: function() {
            return false
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/helpers/vrij/customer.js